/* eslint-disable react/jsx-pascal-case */
import React, { useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import PillNavigation from "../../components/SubNavBar";
import Subscriptions_Items from "./Items";
import { NAV_LIST_SUBSCRIPTION } from "../../dummyData/FoodItemData";
import SubscriptionProduct from "./SubscriptionProduct";

const SubnavBarSubscription = () => {
  const [active, setActive] = useState(1);

  const toggle = (tab: any) => {
    setActive(tab);
  };

  return (
    <div className="subnavbartopdiv">
      <PillNavigation
        navList={NAV_LIST_SUBSCRIPTION}
        active={active}
        toggle={toggle}
      />
      <TabContent className="py-50" activeTab={active}>
        {active === 1 && (
          <div className="subnavbareachpart">
            <TabPane tabId={1}>This is Overview</TabPane>
          </div>
        )}
        {active === 2 && (
          <div className="subnavbareachpart">
            <TabPane tabId={2}>This is Menu</TabPane>
          </div>
        )}
        {active === 3 && (
          <div className="subnavbareachpart">
            <TabPane tabId={3}>
              <SubscriptionProduct />
            </TabPane>
          </div>
        )}
        {active === 4 && (
          <div className="subnavbareachpart">
            <TabPane tabId={4}>
              <Subscriptions_Items />
            </TabPane>
          </div>
        )}
        {active === 5 && (
          <div className="subnavbareachpart">
            <TabPane tabId={5}>this </TabPane>
          </div>
        )}
      </TabContent>
    </div>
  );
};

export default SubnavBarSubscription;
